// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../Config.bs.js";
import * as PretendAsCallerRepo from "./PretendAsCallerRepo.bs.js";
import * as PretendAsCallerDummyRepo from "./PretendAsCallerDummyRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return PretendAsCallerDummyRepo.PretendAsCallerRepo;
  } else {
    return PretendAsCallerRepo.PretendAsCallerRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
